import { USEROLES, DELEGATIONS_SWITCH_CONFIG, SWITCHOPTIONS } from 'common/domain/constants';
import { MODULE_ID as FOOD_BENEFIT_MODULE_ID} from 'food-benefit.module/common/domain/constants';
import { MODULE_ID as VACATIONS_ABSENCES_MODULE_ID} from 'vacations-absences.module/common/domain/constants';

class ModalCreateDelegationController {
  constructor(EventEmitter, DelegationService, $scope, floatingActionButtonsService) {
    'ngInject';
    this.EventEmitter = EventEmitter;
    this.DelegationService = DelegationService;
    this.scope = $scope;
    this.switchOptions = DELEGATIONS_SWITCH_CONFIG;
    this.floatingActionButtonsService = floatingActionButtonsService;
  }

  $onInit() {
    this.initStartDate = null;
    this.initEndDate = null;
    this.sendButtonDisabled = true;
    this.delegationType = this.initDelegationType();

    if (this.isMobileApp) {
      this.floatingActionButtons = this.getFloatingActionButtons();

      this.scope.$watch(() => this.form.$invalid, () => this.setFloatingActionButtonDisabled());
      this.scope.$watch(() => this.ongoing, () => this.setFloatingActionButtonDisabled());
      this.scope.$watch(() => this.employeeToDelegate, () => this.setFloatingActionButtonDisabled());
    }
  }

  isInputFocused() {
    return this.floatingActionButtonsService.isFocused;
  }

  initDelegationType() {
    if (this.module === VACATIONS_ABSENCES_MODULE_ID) {
      return SWITCHOPTIONS.MANAGER;
    }
    return SWITCHOPTIONS.USER;
  }

  getFloatingActionButtons() {
    return [
      {
        literal: 'GLOBALS.BUTTON_ACTION.ACTIVATE',
        disabled: true
      }, {
        literal: 'GLOBALS.BUTTON_ACTION.CANCEL'
      }
    ];
  }

  setFloatingActionButtonDisabled() {
    this.floatingActionButtons[0].disabled = this.setButtonDisabled();
  }

  formatSearch(dataArray) {
    let delegables = [];
    dataArray.forEach((data) => {
      let delegable = {};
      delegable.name = data.employeeName || '';
      delegable.userId = data.employeeId || '';
      delegables.push(delegable);
    });

    return delegables;
  }

  onSearch($event) {
    return this.DelegationService.getDelegableEmployees($event.searchText, this.employeeId).
      then((response) => {
        return this.formatSearch(response.data.delegableEmployees);
      });
  }

  setSelectedEmployee({ $event:$event }) {
    this.employeeToDelegate = $event;
  }

  setDelegationPeriodStartDate($event) {
    this.startDate = $event.date;

    if (this.endDate && (this.startDate > this.endDate)) {
      this.form.startDate.$setValidity('validRange', false);
    } else {
      this.setValidRange();
    }
  }

  setDelegationPeriodEndDate($event) {
    this.endDate = $event.date;

    if (this.startDate && (this.endDate < this.startDate)) {
      this.form.endDate.$setValidity('validRange', false);
    } else {
      this.setValidRange();
    }
  }

  setValidRange() {
    if (!this.startDate) {
      this.initStartDate = angular.copy(this.endDate);
    }

    if (!this.endDate) {
      this.initEndDate = angular.copy(this.startDate);
    }

    this.form.endDate.$setValidity('validRange', true);
    this.form.startDate.$setValidity('validRange', true);
  }

  formatDelegation() {
    let delegation = {
      startDate: this.startDate,
      endDate: this.endDate,
      employee: this.employeeToDelegate.userId,
    };

    return delegation;
  }

  sendDelegation() {
    let delegation = this.formatDelegation();
    this.onSend(this.EventEmitter(delegation));
  }

  setButtonDisabled() {
    return this.form.$invalid || this.ongoing || !this.employeeToDelegate;
  }

  employeeIsManager() {
    return this.role === USEROLES.MANAGER;
  }

  isFoodBenefitModule() {
    return this.module === FOOD_BENEFIT_MODULE_ID;
  }

  isVacationsAbsencesModule() {
    return this.module === VACATIONS_ABSENCES_MODULE_ID;
  }

  showSwitch() {
    return this.isFoodBenefitModule() && this.employeeIsManager();
  }

  setDelegationType($event){
    this.delegationType = $event.$event.option;
    this.onDelegationTypeChange({$event: $event.$event});
  }

}

export default ModalCreateDelegationController;



// WEBPACK FOOTER //
// ./client/app/components/modalDelegationManager/modalCreateDelegation/modalCreateDelegation.controller.js